module.exports = __webpack_public_path__ + "static/media/Resume.f4985f35.pdf";